import {
	IInputValidation,
	IValueValidation,
	InputValidationResultKind
} from "client/Validation/input";
import { IValueReducer } from "../reducer";
import { NewValueHandler } from "./misc";

export interface IAttachableDatePickerProps<TInputValue> {
	value: TInputValue;
	isInvalid: boolean;
	validation: IInputValidation | undefined;
	trackingId: string;
	onChange(value: TInputValue): void;
}

export interface IAttachableDatePickerPropsWithBuilder<TInputValue> extends IAttachableDatePickerProps<TInputValue> {
	withOnChange(
		handler: (newValue: TInputValue) => void
	): IAttachableDatePickerPropsWithBuilder<TInputValue>;
}

export class AttachableDatePickerPropsWithBuilder<TInputValue> implements IAttachableDatePickerPropsWithBuilder<TInputValue> {
	private readonly _reducer: IValueReducer<TInputValue>;
	private readonly _extraOnChangeHandlers: NewValueHandler<TInputValue>[];

	public readonly value: TInputValue;
	public readonly isInvalid: boolean;
	public readonly validation: IInputValidation | undefined;
	public readonly trackingId: string;

	constructor (
		reducer: IValueReducer<TInputValue>,
		validation?: IValueValidation<TInputValue>
	) {
		this._reducer = reducer;
		this.validation = validation;
		this._extraOnChangeHandlers = [];

		this.value = this._reducer.value;
		this.isInvalid = this.validation
			? this.validation.getValidationState().kind === InputValidationResultKind.Invalid
			: false;

		this.trackingId = reducer.path;

		this.onChange = this.onChange.bind(this);
		this.withOnChange = this.withOnChange.bind(this);
	}

	public withOnChange(handler: (newValue: TInputValue) => void): IAttachableDatePickerPropsWithBuilder<TInputValue> {
		this._extraOnChangeHandlers.push(handler);
		return this;
	}

	public onChange(newValue: TInputValue) {
		this._reducer.setValue(newValue);

		if (this.validation) {
			this.validation.triggerInputFinished();
		}

		for (const handler of this._extraOnChangeHandlers) {
			handler(newValue);
		}
	}
}
